var generateStyle = function generateStyle(componentTheme) {
  return {
    empty: {
      padding: componentTheme.emptyPadding,
      fontSize: componentTheme.emptyFontSize,
      textAlign: 'center',
      color: componentTheme.emptyColor
    }
  };
};
export default generateStyle;